import React, { ReactNode } from "react"
import { twElementStyles } from "../../twElementStyles"
import { FieldErrorsImpl, DeepRequired, FieldValues } from 'react-hook-form'
import { getKey } from "../../services/util"
interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string | ReactNode,
    register?: any,
    type?: string,
    errors?: FieldErrorsImpl<DeepRequired<FieldValues>>
}
export const TextField: React.FC<TextFieldProps> = ({ label, register, errors, type, ...props }) => {
    let fieldName = register.name;
    let random = `Infel` + Math.round(Math.random() * 10000)
    let error = getKey(fieldName, errors)

    return (
        <div>
            <div className="relative h-fit">
                <input id={random} type={type} className={` block rounded-t-lg px-2.5 pb-2.5 pt-5 w-full text-sm border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 peer placeholder:text-transparent focus:placeholder:text-gray-500 dark:focus:placeholder:text-gray-300 text-gray-900  disabled:opacity-70 disabled:pointer-events-none bg-gray-100 dark:bg-slate-700 ${error ? 'border-red-500 dark:text-white dark:border-red-500' : 'border-gray-300 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:border-blue-600 dark:hover:border-blue-500 hover:border-blue-600 '}`} {...register} {...props} placeholder={props.placeholder ?? ' '} />
                {
                    label && <label htmlFor={random} className={`absolute text-sm font-semibold duration-300 transform -translate-y-4 text-[.7rem] top-4 z-10 origin-[0] left-2.5 peer-placeholder-shown:text-sm peer-placeholder-shown:translate-y-0 peer-focus:text-[.7rem] peer-focus:-translate-y-4 
                        `}>{label} {register.required} {register.required ? <span className="text-red-700">*</span> : ''}</label>
                    // ${error ? 'peer-focus:text-red-600 dark:peer-focus:text-red-400 peer-focus:dark:text-blue-500 text-red-500 dark:text-red-400' : 'peer-focus:text-blue-600 dark:peer-focus:text-blue-400 peer-focus:dark:text-blue-500 text-gray-500 dark:text-gray-400'}
                }
            </div>
            {error?.message && (
                // <p id="outlined_error_help" className="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">
                <p id="outlined_error_help" className="text-red-500 text-xs mt-1">
                    {error?.message?.toString()}
                </p>
            )}

        </div>

    )
}